import { Component } from '@angular/core';
import { FooterComponent } from '../../../landing-page-v2/components/footer/footer.component';
import { HeaderComponent } from '../../../landing-page-v2/components/header/header.component';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  standalone: true,
  imports: [HeaderComponent, FooterComponent],
})
export class PricingComponent {}
